import DataSamplesProcessor from 'js/lib/DataSamplesProcessor';

/**
 * @DOC
 * This function processes data samples received in a response and formats them into a structured object.
 * It is particularly useful for organizing and preparing data samples for further use or display.
 *
 * @HowToUse
 *    const response = await dispatch(fetchDataSamples(dataSetID));
 *    const samples = getDataSetSamplesFromResponse(response);
 */

type ResultType = {
  rawMessage: Record<string, any>;
  nexlaMetaData: {
    sourceType: string;
    ingestTime: number;
    sourceOffset: number;
    sourceKey: string;
    topic: string | null;
    resourceType: string;
    resourceId: number;
    trackerId: {
      source: {
        sourceId: number;
        dataSetId: null | string;
        source: string;
        recordNumber: number;
        version: number;
        initialIngestTimestamp: number;
      };
      sets: any[];
      sink: null | string;
      trackerMode: string;
    };
    eof: boolean;
    lastModified: null | string;
    runId: number;
    tags: null | string[];
  };
};

type GetDataSetSamplesFromResponseArgs = {
  requestInfo: { id: number };
  receivedAt: number;
  result: ResultType[];
};

export function getDataSetSamplesFromSampleArray(id: number, samplesArray: any[]) {
  const outFlat = [];
  const outSamples = [];

  samplesArray.forEach((s) => {
    outSamples.push(DataSamplesProcessor.rorderSampleProperties(s));
    outFlat.push(DataSamplesProcessor.flattenSamples(s));
  });

  let newSamples = {
    lastUpdated: new Date().getDate(),
    original: { out: outSamples },
    flat: { out: outFlat },
  };

  return { [id]: newSamples };
}

export function getDataSetSamplesFromResponse({
  requestInfo: { id },
  receivedAt,
  result,
}: GetDataSetSamplesFromResponseArgs) {
  if (!id || !result.length) return {};

  const newSamples = getDataSetSamplesFromSampleArray(id, result);
  newSamples[id].lastUpdated = receivedAt;
  return newSamples;
}
